import { useDispatch } from 'react-redux';

import { RetrieveDocumentsReferenceInputDto, RetrieveDocumentsReferenceOutputDto } from '@api/ecommerce-xp';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useFetch } from '@hooks';
import { saveSuccessServiceResponse } from '@store';

export const useFetchBankRetrieveDocumentsReference = (): UseFetchHookOutput<
	Omit<RetrieveDocumentsReferenceInputDto, 'metadata'>,
	RetrieveDocumentsReferenceOutputDto
> => {
	const dispatch = useDispatch();

	return useFetch<RetrieveDocumentsReferenceInputDto, RetrieveDocumentsReferenceOutputDto>({
		operationKey: 'retrieveDocumentsReference',
		withLoading: false,
		onSuccess: (res) => {
			if (res) {
				dispatch(saveSuccessServiceResponse({ retrieveBankDocumentReference: res.data }));
			}
		},
	});
};
